// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f8a81bcf","455":"9fa0fd50","977":"bd1e551f"}[chunkId] + ".chunk.js";
};